import { useState } from "react";
import { MainLayout } from "@components/layouts/MainLayout";
import { LightbulbIcon } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import { requestOpenAiData } from "../../helpers/requestOpenAiData";
import PromptPlayerData from "../../components/players/artificial-intelligence/PromptPlayersData";

const ArtificialIntelligence = () => {
  const [prompt, setPrompt] = useState("");
  const [answer, setAnswer] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAsk = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setAnswer(null);
    try {
      const data = await requestOpenAiData(prompt);
      setAnswer(data.answer || JSON.stringify(data));
    } catch (err: any) {
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<LightbulbIcon className="h-6 w-6 text-blue-600" />}
            title="Artificial Intelligence"
            subtitle="Use a large lanugage model (LLM) to ask questions about players data."
          />
        </div>
        <Separator className="mb-12" />
        <PromptPlayerData
          prompt={prompt}
          setPrompt={setPrompt}
          answer={answer}
          loading={loading}
          error={error}
          onSubmit={handleAsk}
        />
      </div>
    </MainLayout>
  );
};

export default ArtificialIntelligence;
